export default __webpack_public_path__ + "static/media/6_3.4ffd5769.jpg";